<template>
  <div class='preview-layer'>
    <img @click='handleClose' class='layer-close' :src='closeBtnGrayPic'/>
    <div class='layer-content'>
      <slot name="context"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewLayer",
  data() {
    return {
      closeBtnGrayPic: require("@/assets/MediaCenter/close_btn_gray.png")
    }
  },
  methods: {
    handleClose() {
      this.$emit("close", true);
    }
  }
}
</script>

<style lang="less" scoped>
/*预览弹窗*/
.preview-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  background-color: #000000;
  & .layer-close {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 20px;
    width: 20px;
  }
  & .layer-content {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 221px;
    transform: translateY(-50%);
    & .pic {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>